'use client';

import {styled} from "@mui/system";
import ArticleTitleBase from "@/src/components/journal-site/common/article/mui-custom/article-title/article-title";

const ArticleTitle = styled(ArticleTitleBase)(({theme}) => ({
    marginBottom: 0,
    [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
    },
}));

export default ArticleTitle;
